<template>
  <div>
    <component v-if="isActive" v-bind:is="dynamicComponent"></component>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

const PreviewEvent = () => import('@/components/popups/previewEventInfoPopup.vue');
const PreviewShop = () => import('@/components/popups/previewShopInfoPopup.vue');
const PreviewOffer = () => import('@/components/popups/previewOfferInfoPopup.vue');

export default Vue.extend({
  name: 'preview-popup',
  components: {
    'preview-event': PreviewEvent,
    'preview-shop': PreviewShop,
    'preview-offer': PreviewOffer,
  },
  computed: {
    dynamicComponent(): string {
      return this.$store.state.popupPreviewName;
    },
    isActive(): boolean {
      return this.dynamicComponent !== '';
    }
  }
});
</script>
